import React from "react";
var SignOut = function (props) {
    return (React.createElement("div", { className: "signOut" },
        React.createElement("div", null,
            React.createElement("div", { className: "signOut__wave" },
                React.createElement("img", { src: require("../../images/icon-hand.png").default, alt: "" })),
            React.createElement("h6", { className: "h6" }, "You are now signed out."))));
};
export default SignOut;
